export default {output:'出力'};